import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

const THEME_CLASSES = ['dark', 'theme-earth'];

export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';

  const isDark =
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark';

  document.body.classList.remove(...THEME_CLASSES);

  if (selectedColorScheme === 'earth') {
    document.body.classList.add('theme-earth');
    document.documentElement.style.setProperty('color-scheme', 'light');
  } else if (isDark) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
};
